import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, ModalContent, ModalFooter, ModalFooterButtons, ModalHeader } from 'ui/molecules/modal';
import useClipboard from 'ui/hooks/use-clipboard';

interface NoInvestmentDocumentsInvitationModalProps {
  onClose: () => void;
  invitationLink: string;
}

const NoInvestmentDocumentsInvitationModal: FunctionComponent<NoInvestmentDocumentsInvitationModalProps> = (props) => {
  const { onClose, invitationLink } = props;
  const { copy, copied } = useClipboard();

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="issuerProductDetails.invitations.invitationDetails.noInvestmentDocumentsModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="issuerProductDetails.invitations.invitationDetails.noInvestmentDocumentsModal.description" />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: onClose,
            },
            {
              name: 'copyLinkToClipboard',
              content: <Translate name={`copy.link.${!copied ? 'copy' : 'copied'}`} />,
              variant: 'primary',
              disabled: copied,
              onClick: () => copy(invitationLink),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default NoInvestmentDocumentsInvitationModal;
